import request from '@host-panel/request';
import { setNetworkIdInjectorValue, setSpotIdInjectorValue } from '@spotim/fed-common';
import { DEFAULT_NETWORK_ID, DEFAULT_NETWORK_NAME } from '../models/network-types';
import { syncSpotIdToRedux } from 'state/helpers/syncHelpers';

var spotId = undefined;

var token = undefined;

let jwtToken = undefined;

let openwebToken = undefined;

var network = {
  id: DEFAULT_NETWORK_ID,
  name: DEFAULT_NETWORK_NAME,
  imageId: null,
  color: '#307fe2'
};

export function setJWTToken(_jwtToken) {
  jwtToken = _jwtToken;
}

export function getJWTToken() {
  return jwtToken;
}

export function setToken(_token) {
  token = _token;
}

export function getToken() {
  return token;
}

export function getSpotId() {
  return spotId;
}

export function setSpotId(_spotId) {
  if (spotId !== _spotId) {
    spotId = _spotId;
    // I hate this one, but we still have to support @spotim/fed-resources
    // so x-spotim-spotid header will be synced on every spotId change
    setSpotIdInjectorValue(spotId);
    syncSpotIdToRedux(spotId);
  }
}

export function setNetwork(data) {
  if (data) {
    network.id = data.network_id;
    network.name = data.network_name || network.name;
    network.imageId = data.network_image_id || network.imageId;
    network.color = data.network_color || network.color;
    setNetworkIdInjectorValue(data.network_id);
  }
}

export function getNetwork() {
  return network;
}

export function isDefaultNetwork() {
  return DEFAULT_NETWORK_ID === network.id;
}

export const isSocialLoginEnableForNetwork = () => {
  switch (network.id) {
    // this is for test on staging
    case 'net_msnstagingstaging':
    case 'net_whatsonnetflix':
      return true;
    default:
      return false;
  }
};

export async function setAccessToken(overrideSpotId) {
  // We are waiting here for access token to be available
  await request('/login-registered', {
    method: 'POST',
    service: 'me',
    data: {
      spot_id: overrideSpotId ?? spotId
    },
    headers: { 'x-spotim-token': token, 'x-spotim-networkid': network.network_id },
    addJWTtoLocalStorage: true
  });
}
